<template>
   <div class="box">
      <el-form :model="sendDataInfo" ref="sendDataInfo" label-width="100px" class="demo-ruleForm">
         <el-form-item label="年月" prop="name">
            <el-date-picker class="input" @clear="clearClick" v-model="sendDataInfo.value" @change="selectChange" type="month" value-format="yyyy-MM" placeholder="选择年月">
            </el-date-picker>
         </el-form-item>
         <el-form-item label="成本金额" prop="name">
            <el-input class="input" type="number" v-model.trim="sendDataInfo.totalCostMoney"></el-input>
         </el-form-item>
         <el-form-item label="总毛利" prop="name">
            <el-input class="input" type="number" v-model.trim="sendDataInfo.totalGross" readonly></el-input>
         </el-form-item>
         <el-form-item label="总金额" prop="name">
            <el-input class="input" type="number" v-model.trim="sendDataInfo.totalPsmoney" readonly></el-input>
         </el-form-item>
         <el-form-item>
            <el-button type="primary" @click="submitForm()">更新</el-button>
         </el-form-item>
      </el-form>
   </div>
</template>

<script>
export default {
   name: 'retailCostAdjustmentUpdata',
   data() {
      return {
         sendDataInfo: {
            name: '',
            value: "",
            totalCostMoney: 0,
            totalGross: 0,
            totalPsmoney: 0,
         }
      }
   },
   created() {
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      this.sendDataInfo.value = this.$moment(lastMonth).format("yyyy-MM")
      this.selectChange()
   },
   methods: {
      async submitForm() {
         if (this.sendDataInfo.value == "") {
            return this.$message.error('请选择年月')
         } else if (this.sendDataInfo.totalCostMoney == 0 || this.sendDataInfo.totalCostMoney == "") {
            return this.$message.error('请输入成本金额')
         }
         const params = {
            month: this.sendDataInfo.value.split('-')[1],
            year: this.sendDataInfo.value.split('-')[0],
            newCbMoney: this.sendDataInfo.totalCostMoney,
         }
         const res = await this.$http.retailchangeCurCb(params)
         if (res.status == 200) {
            this.$alert(res.message, '提示', {
               confirmButtonText: '确定',
               callback: action => {
               }
            });
         } else {
            this.$message.error(res.message)
         }
      },
      resetForm(formName) {
         this.$refs[formName].resetFields();
      },
      clearClick() {
         this.sendDataInfo.value = "";
         this.sendDataInfo.totalCostMoney = 0
         this.sendDataInfo.totalGross = 0
         this.sendDataInfo.totalPsmoney = 0
      },
      async selectChange() {
         if (this.sendDataInfo.value == "") {
            return this.$message.error('请选择年月')
         }
         const params = {
            month: this.sendDataInfo.value.split('-')[1],
            year: this.sendDataInfo.value.split('-')[0]
         }
         const res = await this.$http.retailgetCurCb(params)
         if (res.status == 200) {
            if (res.result) {
               this.sendDataInfo.totalCostMoney = res.result.totalCostMoney
               this.sendDataInfo.totalGross = res.result.totalGross
               this.sendDataInfo.totalPsmoney = res.result.totalPsmoney
            } else {
               this.sendDataInfo.totalCostMoney = 0
               this.sendDataInfo.totalGross = 0
               this.sendDataInfo.totalPsmoney = 0

            }
         }
      }
   }
}
</script>

<style scoped>
.box {
   padding: 10px;
}
.input {
   width: 300px;
}
</style>